<template>
  <div style="position: relative">
    <div v-if="loading" class="progress-bar">
      <div class="progress-bar-value"></div>
    </div>
    <div v-if="loading" class="loading-overlay"></div>
    <div class="d-flex justify-content-between align-items-center">
      <h3>
        <feather-icon size="23" icon="GitBranchIcon" />
        الفروع والمكاتب
      </h3>
      <b-button
        @click="newBranchModal = true"
        variant="success"
        v-can="{ slug: $route.meta.slug, action: 'C' }"
        v-if="!ngoData.completed_by_ngo"
      >
        <feather-icon size="15" class="mr-25" icon="PlusIcon" />
        إضافة فرع
      </b-button>
    </div>
    <hr />

    <section>
      <h4 class="text-primary pl-1 mt-4">الفروع</h4>
      <hr />
      <app-collapse v-if="branchesList.length > 0" accordion>
        <app-collapse-item
          class="border rounded my-2"
          v-for="branch in branchesList"
          :key="branch.id"
          :title="branch.governorate_name"
        >
          <template #header>
            <div
              class="d-flex w-100 justify-content-between align-items-center"
            >
              <h5>
                {{ branch.governorate_name }}
              </h5>
              <div>
                <b-dropdown
                  v-if="!ngoData.completed_by_ngo"
                  variant="link"
                  no-caret
                  :right="true"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item
                    variant="primary"
                    @click="openEditBranchModal(branch)"
                  >
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">تعديل</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-can="{ slug: $route.meta.slug, action: 'D' }"
                    variant="danger"
                    @click="onDeleteBranch(branch.id)"
                  >
                    <feather-icon icon="Trash2Icon" />
                    <span class="align-middle ml-50">حذف</span>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </template>
          <div class="d-flex">
            <b-row class="w-100">
              <b-col cols="6">
                <info-card
                  label="نوع الفرع"
                  :value="branch.branchType.name_ar"
                />
              </b-col>

              <b-col cols="6">
                <info-card label="العنوان التفصيلي" :value="branch.address" />
              </b-col>

              <b-col cols="6">
                <info-card
                  label="رقم العقار"
                  :value="branch.realEstate ? branch.realEstate.number : ''"
                />
              </b-col>
              <b-col cols="6">
                <info-card label="الخدمات المقدمة" :value="branch.services" />
              </b-col>
              <b-row  class="info-card w-100 mx-2 py-1 my-1" v-if="branch.hasOwnProperty('administrativeCommitteeMembers') && branch.administrativeCommitteeMembers.length > 0 ">  

                <b-col cols="12" class="my-2">
                    <h5>
                        اللجنة الإدارية :
                    </h5>
                </b-col>
                <b-col md="12" cols="12">
                    <div>
                        <b-tabs content-class="mt-3">
                            <b-tab v-for="(member , i) in branch.administrativeCommitteeMembers" :key="i" :title="`العضو ${ getArrangement(i+1) }`">
                                <b-row>
                                    <b-col md="6" cols="12">
                                        <info-card
                                        label="الاسم الكامل للعضو"
                                        :value="member.employee ? `${member.employee.first_name} ${member.employee.father_name} ${member.employee.last_name} ` :''"
                                        />
                                    </b-col>
                                        
                                    <b-col cols="6">
                                        <div class="info-card px-2 py-1 my-1">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <div>
                                              نشرة استعلامه
                                            </div>
                                            <div>
                                            <b-button
                                                variant="flat-info"
                                                v-b-toggle.doc-view
                                                class="btn-icon mx-25"
                                                v-b-tooltip.hover.v-info.bottom
                                                title="عرض المستند المرفوع"
                                                :to="{ name: 'file-view', query: { ep:member.security_dossier } }"
                                            >
                                                <feather-icon icon="EyeIcon"
                                            /></b-button>
                                            </div>
                                        </div>
                                        <div>
                                            <hr />
                                        </div>
                                        </div>
                                    </b-col> 
                                </b-row>
                            </b-tab>
                        </b-tabs>
                    </div>
                </b-col>  
              </b-row>
              <b-col cols="6" v-else>
                <info-card
                  label="اللجنة الإدارية"
                  :value="branch.management_committee"
                />
              </b-col>

            </b-row>
          </div>
        </app-collapse-item>
      </app-collapse>
      <div v-else>
        <div class="text-center p-1" style="opacity: 0.6">
          <h5 class="text-warning">
            <feather-icon class="mx-25" icon="AlertTriangleIcon" />

            لا يوجد سجلات حتى الآن
          </h5>
        </div>
      </div>
    </section>

    <section class="mt-4">
      <h4 class="text-primary pl-1 mt-4">المكاتب</h4>
      <hr />
      <app-collapse v-if="departmentsList.length > 0" accordion>
        <app-collapse-item
          class="border rounded my-2"
          v-for="branch in departmentsList"
          :key="branch.id"
          :title="branch.governorate_name"
        >
          <template #header>
            <div
              class="d-flex w-100 justify-content-between align-items-center"
            >
              <h5>
                {{ branch.governorate_name }}
              </h5>
              <div>
                <b-dropdown
                  v-if="!ngoData.completed_by_ngo"
                  variant="link"
                  no-caret
                  :right="true"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item
                    variant="primary"
                    @click="openEditBranchModal(branch)"
                  >
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">تعديل</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-can="{ slug: $route.meta.slug, action: 'D' }"
                    variant="danger"
                    @click="onDeleteBranch(branch.id)"
                  >
                    <feather-icon icon="Trash2Icon" />
                    <span class="align-middle ml-50">حذف</span>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </template>
          <div class="d-flex">
            <b-row class="w-100">
              <b-col cols="6">
                <info-card
                  label="نوع الفرع"
                  :value="branch.branchType.name_ar"
                />
              </b-col>

              <b-col cols="6">
                <info-card label="العنوان" :value="branch.address" />
              </b-col>

              <b-col cols="6">
                <info-card
                  label="رقم العقار"
                  :value="branch.realEstate ? branch.realEstate.number : ''"
                />
              </b-col>

              <b-col cols="6">
                <info-card label="الخدمات" :value="branch.services" />
              </b-col>

              <b-col cols="6">
                <info-card
                  label="اللجنة الإدارية"
                  :value="branch.management_committee"
                />
              </b-col>
            </b-row>
          </div>
        </app-collapse-item>
      </app-collapse>
      <div v-else>
        <div class="text-center p-1" style="opacity: 0.6">
          <h5 class="text-warning">
            <feather-icon class="mx-25" icon="AlertTriangleIcon" />

            لا يوجد سجلات حتى الآن
          </h5>
        </div>
      </div>
    </section>

    <branch-modal
      @confirm="onNewBranch"
      :loading="working"
      v-model="newBranchModal"
    />
    <branch-modal
      @confirm="onUpdateBranch"
      :loading="working"
      ref="editBranchModal"
      v-model="editBranchModal"
      :intializeForm.sync="editBranchForm"
    />
  </div>
</template>

<script>
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import { BButton } from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import InfoCard from "@/components/InfoCard.vue";
import BranchModal from "../../components/BranchModal.vue";
import { BRow, BDropdown, BDropdownItem, BCol , BTabs , BTab  ,  VBToggle , VBTooltip  } from "bootstrap-vue";
import formAutocomplete from "@/components/form-autocomplete";
import { arrangement } from "@/utils/utils";
export default {
  components: {
    BButton,
    AppCollapse,
    AppCollapseItem,
    InfoCard,
    BRow,
    BDropdown,
    BDropdownItem,
    BranchModal,
    BCol, BTabs , BTab , 
    formAutocomplete,
  },
  data() {
    return {
      editBranchForm: {},
      editBranchModal: false,
      newBranchModal: false,
    };
  },
  
    
  directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },
  methods: {
    ...mapActions("NgoProfile/Branches", [
      "getBranches",
      "addBranch",
      "editBranch",
      "deleteBranch",
    ]),
    async onNewBranch(payload) {
      await this.addBranch(payload);
      this.newBranchModal = false;
    },
    getArrangement(num){
      return arrangement(num)
    },
    async onUpdateBranch(payload) {
      await this.editBranch(payload);
      this.editBranchModal = false;
    },
    onDeleteBranch(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف الفرع", {
          title: "تأكيد حذف فرع",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) this.deleteBranch(id);
        });
    },
    openEditBranchModal(branch) {
      this.editBranchForm = JSON.parse(
        JSON.stringify({
          id: branch.id,
          branch_type_id: branch.branchType.id,
          decision_date: branch.decision_date,
          management_committee: branch.management_committee,
          services: branch.services,
          sub_district_id: branch.subDistrict.id,
          longitude: branch.longitude,
          latitude: branch.latitude,
          address: branch.address,
          real_estate_id: branch.realEstate ? branch.realEstate.id : null,
        })
      );
      this.$refs.editBranchModal.init(this.editBranchForm);
      this.editBranchModal = true;
    },
  },
  computed: {
    ...mapGetters("NgoProfile", ["ngoData"]),
    ...mapGetters("NgoProfile/Branches", ["branches", "loading", "working"]),

    branchesList() {
      return this.branches.filter(
        (el) =>
          el.branchType.name_ar !== "مكتب" && el.branchType.name_ar !== "فرع أم"
      );
    },
    departmentsList() {
      return this.branches.filter((el) => el.branchType.name_ar === "مكتب");
    },
  },
  created() {
    this.getBranches();
  },
};
</script>

<style lang="scss">
.btn.dropdown-toggle {
  padding: 0px;
}
</style>
